/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */


document.addEventListener('DOMContentLoaded', () => {

  // payment icons on product pages 
  /*
  const prodBody = document.querySelector('.template-product, body[class*="template-product."]');
  if (prodBody) { 
    var paymentIconsFn = setInterval( ()=>{
      const payTrigger = document.querySelector('.afterpay-paragraph');
      if (payTrigger) {payTrigger.classList.add('content-loaded')}
      if(payTrigger.classList.contains('content-loaded')){
        clearInterval(paymentIconsFn);
        let payIcons = `<img src="//wholesale.neoflam.com.au/cdn/shop/t/14/assets/payIcons1.png?v=67968618780051894341775016801" alt="" />`;
        document.querySelector('.afterpay-text1').innerHTML = 'or 4 payments of with ';
        document.querySelector('.afterpay-text2').style.display = "none";
        document.querySelector('.afterpay-logo').style.display = "none";
        document.querySelector('.afterpay-link').style.display = "none";
        document.querySelector('.afterpay-text3').innerHTML = `${payIcons}`;
      }
    },100);
  }
  */
  
    // custom gallary sorting
    const isoInerval = setInterval(() => {
      const isoLoad = document.querySelector('.iso-gallery-section');
      if (isoLoad) {
        isoLoad.classList.add('gallery-loaded');
        if (isoLoad.classList.contains('gallery-loaded')) {
          clearInterval(isoInerval);
          const tabstrigger = document.querySelectorAll('.iso-tabs-wrapper button');
          const targetEle = document.querySelectorAll('.iso-gallery-wrapper .img-wrapper');
          tabstrigger.forEach(ele => {
            ele.addEventListener('click', (e) => {
              tabstrigger.forEach(element => {
                element.classList.remove('active');
              });
              e.target.classList.add('active');
              if (e.target.id == 'all') {
                targetEle.forEach(tarEle => {
                  tarEle.style.display = 'block';
                });
              }else{
                const targetAttr = e.target.getAttribute('data-filter');
                targetEle.forEach(tarEle => {
                  const currTarAttr = tarEle.getAttribute('data-category');
                  if (targetAttr === currTarAttr || targetAttr == currTarAttr ) {
                    tarEle.style.display = 'block';
                  }else{
                    tarEle.style.display = 'none';
                  }
                });  
              }
            })
          });
        }
      }
      new FsLightbox();
    }, 100);

    // complete the set metatifled slider
    var completeTheSet = document.querySelector('.product-content__featured-products .cust-scroller__inner');
    new Swiper(completeTheSet, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      freeMode: true,
      loopFillGroupWithBlank: true,
      navigation: {
        nextEl: ".prev-next-button--next",
        prevEl: ".prev-next-button--prev",
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        "769": {
          slidesPerView: 2,
          spaceBetween: 20
        }
      }
    });

    

    // pdp button popup
    const buttonPopTrigger = document.querySelectorAll('.field-btn-wrapper .product-form__button a');
    const buttonPopClose = document.querySelectorAll('.field-btn-wrapper .product-form__button .closebtn');
    const buttonPopTarget = document.querySelectorAll('.field-btn-wrapper .product-form__button .content');
    buttonPopClose.forEach(button => {
      button.addEventListener('click', () => {
        button.parentElement.classList.remove('active');
      })
    });
    buttonPopTrigger.forEach(button => {
      button.addEventListener('click', (e) => {
        if (window.innerWidth >= 768) {
          buttonPopTrigger.forEach(cloBtn => {
            cloBtn.classList.remove('active');
          });
          buttonPopTarget.forEach(ele => {
            ele.classList.remove('active');
          });
        }
        button.classList.toggle('active');
        const targetEle = button.nextElementSibling;
        targetEle.classList.toggle('active');
      })
    });


    //submenu collection page
    const SubmenuColSwiper = new Swiper(".submenu-collection-section .swiper", {
      loop: true,
      spaceBetween: 15, 
      centeredSlides: false,
      slidesPerView: "2.4",
      breakpoints: {
        769: {
          slidesPerView: 4,
          spaceBetween: 20
        },
        1025:{
          slidesPerView: 6,
          spaceBetween: 30
        }
      }
    });

    // product price setup
    $('.price-list .price').each(function () {
      var $this = $(this),
          $val = $this.html(),
          dec_pos = $val.indexOf('.');
        $this.html($val.substring(0, dec_pos) + '<small>.' + $val.substring(dec_pos + 1) + '</small>');
    });

// header searchbar

	const siteHeaderHeight = document.querySelector('#shopify-section-header').clientHeight;
    document.querySelector('predictive-search-drawer.drawer').style.height = `${siteHeaderHeight}px`;
});

document.addEventListener('DOMContentLoaded', () => {
  setTimeout(function () { document.getElementById("custom-sub-menu-collections-list").style.display = "block"; }, 1000);
  var $swiperSelector = $('.custom-sub-menu-collections .swiper-container');
    $swiperSelector.each(function(index) {
    var $this = $(this);
    $this.addClass('swiper-slider-' + index);
    
    var dragSize = $this.data('drag-size') ? $this.data('drag-size') : 50;
    var freeMode = $this.data('free-mode') ? $this.data('free-mode') : false;
    var loop = $this.data('loop') ? $this.data('loop') : false;
    var slidesDesktop = $this.data('slides-desktop') ? $this.data('slides-desktop') : 6;
    var slidesTablet = $this.data('slides-tablet') ? $this.data('slides-tablet') : 6;
    var slidesMobile = $this.data('slides-mobile') ? $this.data('slides-mobile') : 3.5;
    var spaceBetween = $this.data('space-between') ? $this.data('space-between'): 20;

    var swiper = new Swiper('.swiper-slider-' + index, {
      direction: 'horizontal',
      loop: loop,
      freeMode: freeMode,
      spaceBetween: spaceBetween,
      breakpoints: {
        1920: {
          slidesPerView: slidesDesktop
        },
        992: {
          slidesPerView: slidesTablet
        },
        320: {
           slidesPerView: slidesMobile
        }
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
        dragSize: dragSize
      }
   });
});
 
});

window.addEventListener("resize",  () => {
  let win_width = document.documentElement.clientWidth;
  if (win_width > 992) {
      var $swiperSelector = $('.custom-sub-menu-collections .swiper-container');
            $swiperSelector.each(function(index) {
            var $this = $(this);
            $this.addClass('swiper-slider-' + index);
            
            var dragSize = $this.data('drag-size') ? $this.data('drag-size') : 50;
            var freeMode = $this.data('free-mode') ? $this.data('free-mode') : false;
            var loop = $this.data('loop') ? $this.data('loop') : false;
            var slidesDesktop = $this.data('slides-desktop') ? $this.data('slides-desktop') : 6;
            var slidesTablet = $this.data('slides-tablet') ? $this.data('slides-tablet') : 6;
            var slidesMobile = $this.data('slides-mobile') ? $this.data('slides-mobile') : 3.5;
            var spaceBetween = $this.data('space-between') ? $this.data('space-between'): 20;
        
            var swiper = new Swiper('.swiper-slider-' + index, {
              direction: 'horizontal',
              loop: loop,
              freeMode: freeMode,
              spaceBetween: spaceBetween,
              breakpoints: {
                1920: {
                  slidesPerView: slidesDesktop
                },
                992: {
                  slidesPerView: slidesTablet
                },
                320: {
                   slidesPerView: slidesMobile
                }
              },
              navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
              },
              scrollbar: {
                el: '.swiper-scrollbar',
                draggable: true,
                dragSize: dragSize
              }
           });
        });
  }
});